import {
  anEntityInterface,
  anInsight,
  aRelatedIncident,
  aSignal,
  EntityReputationSource,
  InsightSeverityPyEnum,
  mockInsightAsideQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { handlers as featureFlagHandlers } from '@sbu/hooks.featureflag/build/mocks';
import { handlers as tagsHandlers } from '@sbu/hooks.tags/build/mocks';

export const mockInsight = anInsight({
  readableId: 'INSIGHT-53',
  name: 'Defense Evasion',
  description:
    'The rule looks for the Registry Key DisableAntiSpyware set to disable. This is consistent with Ryuk infections across a fleet of endpoints.',
  entity: anEntityInterface({
    id: '_hostname-MATCH549TEST2.amer.somecompany.com',
    entityType: '_hostname',
    entityTypeName: 'Hostname',
    name: 'MATCH549TEST2.amer.somecompany.com',
    reputation: 'Suspicious',
    reputationSources: [EntityReputationSource.ThreatIntelligence],
  }),
  severity: InsightSeverityPyEnum.Low,
  confidence: 0.35,
  relatedIncidents: [
    aRelatedIncident({
      assignee: 'mb (group)',
      id: 103905,
      link: 'https://staging.soar.sumologic.com//incmansuite_ng/lib/gui/app.php#incident|103905|details',
      name: 'INSIGHT-53 Incident',
      status: 'Open',
      type: 'incident',
    }),
  ],
  signals: [
    aSignal({
      id: 'c3e27f94-29b7-5e36-bc49-995cf57e3615',
      timestamp: '2023-05-24T11:01:45.898000',
    }),
    aSignal({
      id: 'd3e27f94-29b7-5e36-bc49-995cf57e3614',
      timestamp: '2023-05-27T11:01:45.898000',
    }),
  ],
  uniqueSignalCount: 2,
  signalCount: 2,
  timestamp: '2023-05-24T18:01:45.898000',
  created: '2023-05-24T18:45:50.530691',
  tags: [
    '_mitreAttackTactic:TA0005',
    '_mitreAttackTechnique:T1562',
    '_mitreAttackTechnique:T1562.001',
    '_mitreAttackTechnique:T1562.006',
    'Servicenow Incident Linked',
  ],
});

export const handlers = [
  mockInsightAsideQuery(async ({ query: _query, variables: _variables }) => {
    await delay(1500);
    return HttpResponse.json({
      data: {
        __typename: 'Query',
        insight: mockInsight,
      },
    });
  }),
  ...tagsHandlers,
  ...featureFlagHandlers,
];
